import { useMemo } from 'react';
import { useCurrentUser, useUserActions } from 'stores/useUserStore';

import ImpersonationError from 'components/ui/shared/ImpersonationError';
import { BannerStyle } from 'enums/bannerStyle';
import { ElementTestId } from 'enums/testing';
import { impersonationManager } from 'utils/impersonationUtils';
import { translate } from 'utils/intlUtils';

import Banner from './Banner';

const { t } = translate;

const LoggedInAsBanner = () => {
  const { displayName } = useCurrentUser();
  const { impersonateAsUser } = useUserActions();

  const banner = useMemo(() => {
    if (!impersonationManager.isCurrentlyImpersonating) {
      return null;
    }

    // Keep the banner in the actual user's language, even when the impersonated user's locale differs.
    const translationOptions = { lng: impersonationManager.getActualUser()?.locale?.languageTag };

    return (
      <Banner
        ctaLabel={t('logout', undefined, translationOptions)}
        ctaTestId={ElementTestId.LOGGED_IN_AS_BANNER_LOGOUT_LINK}
        onClick={() => impersonateAsUser(undefined)}
        styleVariant={BannerStyle.IMPERSONATION}
        testId={ElementTestId.LOGGED_IN_AS_BANNER}
        title={t('logged_in_as_message', [displayName], translationOptions)}
      />
    );
  }, [displayName, impersonateAsUser]);

  return (
    <>
      <ImpersonationError />
      {banner}
    </>
  );
};

export default LoggedInAsBanner;
